// 検索条件を共有するためのState (URLへの反映は別途)
import type { MapSelectParam } from "~/types/entity/cWebCatalog";

const getDefaultValue = (): MapSelectParam => ({
  category: "CIRCLE",
});

export const useMapSearchState = () => {
  const state = useState<MapSelectParam>("mapSearchParamForState", getDefaultValue);

  // アプリケーション内でグローバルな state の操作は影響範囲が大きいので 手軽に使える値の操作として公開せず
  // 関数呼び出しとして見せる
  return {
    /**
     * パラメータとして取得する
     */
    get: () => state.value,
    /**
     * パラメータを更新する
     * @param v
     * @returns
     */
    set: (v: MapSelectParam) => state.value = v,
    /**
     * 初期状態
     */
    getDefaultValue,
  };
};
